/**
 * Classification Analytics Page
 * Dashboard for skill execution and classification analysis
 */

import { useState } from 'react';
import { TrendingUp } from 'lucide-react';
import { SkillExecutionAnalytics } from '@/components/analytics/SkillExecutionAnalytics';
import { ClassificationLogAnalytics } from '@/components/analytics/ClassificationLogAnalytics';
import { useI18n } from '@/i18n';

type TabType = 'skillExecution' | 'classification';

export function ClassificationAnalyticsPage() {
  const { messages } = useI18n();
  const t = messages.classificationAnalytics;

  const [activeTab, setActiveTab] = useState<TabType>('skillExecution');

  const tabs: { key: TabType; label: string }[] = [
    { key: 'skillExecution', label: t.tabs.skillExecution },
    { key: 'classification', label: t.tabs.classification },
  ];

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <TrendingUp className="w-8 h-8 text-blue-600" />
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{t.pageTitle}</h1>
          <p className="text-sm text-gray-500 mt-1">{t.pageDescription}</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="flex gap-4">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                activeTab === tab.key
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'skillExecution' && <SkillExecutionAnalytics />}
        {activeTab === 'classification' && <ClassificationLogAnalytics />}
      </div>
    </div>
  );
}

export default ClassificationAnalyticsPage;
